export class ProfileStoreError extends Error {
  // This gives the error type safety
  private readonly typeName = 'ProfileStoreError'
  public readonly name = this.typeName

  constructor(message: string) {
    super(`Error in the backup ProfileStore: ${message}`)
  }
}
